import { login, logout, getInfo, refresh } from "@/api/user";
import { getToken, setToken, removeToken } from "@/utils/auth";
import router, { } from "@/router";

const state = {
  token: getToken(),
  name: "",
  avatar: "",
  introduction: "",
  roles: [],
  role: ""
};

const mutations = {
  SET_TOKEN: (state, token) => {
    state.token = token;
  },
  SET_INTRODUCTION: (state, introduction) => {
    state.introduction = introduction;
  },
  SET_NAME: (state, name) => {
    state.name = name;
  },
  SET_AVATAR: (state, avatar) => {
    state.avatar = avatar;
  },
  SET_ROLES: (state, roles) => {
    state.roles = roles;
  },
  SET_ROLE: (state, role) => {
    state.role = role;
  }
};

const actions = {
  // user login
  login({ commit }, userInfo) {
    const { username, password } = userInfo;
    return new Promise((resolve, reject) => {
      login({ username: username.trim(), password: password })
        .then(response => {
          const { data } = response;
          commit("SET_TOKEN", data.access_token);
          setToken(data.access_token);
          resolve();
        })
        .catch(error => {
          reject(error);
        });
    });
  },

  // eslint-disable-next-line no-unused-vars
  refresh({ commit }) {
    return new Promise((resolve, reject) => {
      refresh()
        .then(response => {
          const { data } = response;

          commit("SET_TOKEN", data.access_token);
          setToken(data.access_token);
          return resolve(data.access_token);
        })
        .catch(error => {
          reject(error);
        });
    });
  },

  // get user info
  getInfo({ commit, state }) {
    return new Promise((resolve, reject) => {
      getInfo(state.token)
        .then(response => {
          const { user } = response.data;

          if (!user) {
            reject("Verification failed, please Login again.");
          }
          const roles = ["user"];
          const { name, avatar, introduction, Role } = user;


          // roles must be a non-empty array
          if (!roles || roles.length <= 0) {
            reject("getInfo: roles must be a non-null array!");
          }

          commit("SET_ROLES", roles);
          commit("SET_ROLE", Role.name);
          commit("SET_NAME", name);
          commit("SET_AVATAR", avatar);
          commit("SET_INTRODUCTION", introduction);
          resolve(user);
        })
        .catch(error => {
          reject(error);
        });
    });
  },

  // user logout
  logout({ commit, state }, payload) {

    return new Promise((resolve, reject) => {

      removeToken();
      commit("SET_ROLES", "");
      commit("SET_ROLE", "");
      commit("SET_NAME", "");
      commit("SET_AVATAR", "");
      commit("SET_INTRODUCTION", "");
      resolve();
    });
  },

  // remove token
  resetToken({ commit }) {
    return new Promise(resolve => {
      commit("SET_TOKEN", "");
      commit("SET_ROLES", []);
      removeToken();
      resolve();
    });
  },

  // dynamically modify permissions
  // eslint-disable-no-async-promise-executor
  // eslint-disable-next-line no-console
  changeRoles({ commit, dispatch }, role) {
    // eslint-disable-next-line no-console
    /* eslint no-console: ["error", { allow: ["warn"] }] */
    return new Promise(async resolve => {
      const token = role + "-token";

      commit("SET_TOKEN", token);
      setToken(token);

      const { roles } = await dispatch("getInfo");
      // generate accessible routes map based on roles
      const accessRoutes = await dispatch("permission/generateRoutes", roles, {
        root: true
      });

      // dynamically add accessible routes
      router.addRoutes(accessRoutes);

      // reset visited views and cached views
      dispatch("tagsView/delAllViews", null, { root: true });

      resolve();
    });
  }
};

export default {
  namespaced: true,
  state,
  mutations,
  actions
};
